export const QUESTIONNAIRE_EVALUATION = 'QUESTIONNAIRE_EVALUATION';
export const QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL = 'QUESTIONNAIRE_EVALUATION_UI';
export const QUESTIONNAIRE_EVALUATION_QUESTION_TYPE = {
    FIRST: 'next-question?limit=first',
    NEXT: 'next-question',
    PREVIOUS: 'previousQuestion'
};
//# sourceMappingURL=QuestionnaireEvaluation.js.map